import React from 'react';
const RendererContext = /*#__PURE__*/React.createContext({});
export const useRendererContext = () => React.useContext(RendererContext);
export const RendererContextProvider = RendererContext.Provider;